import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';

const LojaIndex = lazy(() => import('./Index'));
const LojaCarrinho = lazy(() => import('./Carrinho'));
const LojaMeusPedidos = lazy(() => import('./MeusPedidos'));
const LojaAdmin = lazy(() => import('./Admin'));
const LojaFornecedor = lazy(() => import('./FornecedorPainel'));

export const lojaRoutes: RouteObject[] = [
    {
        path: '/loja-capital',
        element: (
            <ProtectedRoute permission="loja.view">
                <LojaIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: '/loja-capital/carrinho',
        element: (
            <ProtectedRoute permission="loja.view">
                <LojaCarrinho />
            </ProtectedRoute>
        ),
    },
    {
        path: '/loja-capital/pedidos',
        element: (
            <ProtectedRoute permission="loja.view">
                <LojaMeusPedidos />
            </ProtectedRoute>
        ),
    },
    {
        path: '/loja-capital/fornecedor',
        element: (
            <ProtectedRoute permission="loja.fornecedor">
                <LojaFornecedor />
            </ProtectedRoute>
        ),
    },
    {
        path: '/loja-capital/admin',
        element: (
            <ProtectedRoute permission="loja.admin">
                <LojaAdmin />
            </ProtectedRoute>
        ),
    },
];
